export default __webpack_public_path__ + "static/media/money-pariuri.090aa709.svg";